import { VFC } from 'react'
import { Routes, Route } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'

import EmbedContainer from './Embed/Container'

const InteractionRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route
          path=':workflowUuid/:interactionUuid'
          element={<EmbedContainer />}
        />
      </Route>
    </Routes>
  )
}

export default InteractionRoutes
